module.exports = __webpack_public_path__ + "img/ban-icon.f010f915.svg";